namespace AgerLMS.LMS {
    export interface AddressesRow {
        Id?: number;
        UserId?: number;
        Title?: string;
        CityId?: number;
        DistrictId?: number;
        NeighbourhoodId?: number;
        Address1?: string;
        Address2?: string;
        Main?: boolean;
        UserName?: string;
        CityCode?: number;
        CityName?: string;
        DistrictCityId?: number;
        DistrictCode?: number;
        DistrictName?: string;
        NeighbourhoodDistrictId?: number;
        NeighbourhoodName?: string;
        NeighbourhoodPostCode?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace AddressesRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'LMS.Addresses';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            UserId = "UserId",
            Title = "Title",
            CityId = "CityId",
            DistrictId = "DistrictId",
            NeighbourhoodId = "NeighbourhoodId",
            Address1 = "Address1",
            Address2 = "Address2",
            Main = "Main",
            UserName = "UserName",
            CityCode = "CityCode",
            CityName = "CityName",
            DistrictCityId = "DistrictCityId",
            DistrictCode = "DistrictCode",
            DistrictName = "DistrictName",
            NeighbourhoodDistrictId = "NeighbourhoodDistrictId",
            NeighbourhoodName = "NeighbourhoodName",
            NeighbourhoodPostCode = "NeighbourhoodPostCode",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
